/**
 * Water Report Configuration
 * Centralized configuration for the Water Report popup system
 *
 * To change settings, only modify this file.
 */
window.WaterReportConfig = {
  /**
   * n8n Webhook URLs per market
   * IMPORTANT: Switch between TEST and PROD URLs
   */
  webhookUrl: 'https://n8n.srv1334841.hstgr.cloud/webhook/9630eb30-6cf4-46f2-9a97-9600700b659a', // PROD UK
  webhookUrlUS: 'https://n8n.srv1334841.hstgr.cloud/webhook/9630eb30-6cf4-46f2-9a97-9600700b659a', // PROD US

  /**
   * Postcode validation API
   * UK Postcodes API endpoint
   */
  postcodeApiUrl: 'https://api.postcodes.io/postcodes',

  /**
   * Popup behavior settings
   */
  showDelay: 10000, // Delay before auto-showing popup (in milliseconds)
  storageKey: 'wr_popup_shown', // SessionStorage key to track if popup was shown
  debounceDelay: 400, // Debounce delay for postcode validation (in milliseconds)

  // NOTE: market/country visibility used to be restricted here, but these
  // two keys were never actually read by water-report-popup.js (it had its
  // own separate, now-removed, hardcoded allow-list). The only thing that
  // now controls which markets see the popup is the "Popup visibility by
  // market" toggles in the app dashboard (MarketToggle table), checked live
  // via /apps/water-report?action=market-status.

  /**
   * Redirect after successful submission
   * Set to null to just close the popup instead of redirecting
   */
  redirectUrl: '/apps/water-report', // Will append ?token=xxx
  // redirectUrl: null, // Uncomment to disable redirect

  /**
   * Supabase Configuration
   * For tracking popup impressions and form submissions
   */
  // PROD
  supabaseUrl: 'https://hqdmxblzxlwjxgcwyhsx.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhxZG14Ymx6eGx3anhnY3d5aHN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5NjI3NDMsImV4cCI6MjA4NjUzODc0M30.HAISpmHstm_qoQITYc3hZYJP8q9pZjJ6MJWyjZqknqo', // Public anon key (safe for client-side)
  supabaseImpressionUrl: 'https://hqdmxblzxlwjxgcwyhsx.supabase.co/functions/v1/track-popup-impression',
  supabaseFormSubmissionUrl: 'https://hqdmxblzxlwjxgcwyhsx.supabase.co/functions/v1/track-form-submission',

  // LOCAL (ne fonctionne PAS depuis un site distant à cause de CORS/Mixed Content)
  // supabaseUrl: 'http://127.0.0.1:54321',
  // supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0',
  // supabaseImpressionUrl: 'http://127.0.0.1:54321/functions/v1/track-popup-impression',

  /**
   * Storage keys
   */
  sessionIdKey: 'popup_session_id',
  impressionTrackedKey: 'popup_impression_tracked',
};
